import * as icon from "@coreui/icons";

export const singleCountriesOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      const phone_code = item && item.phone_code
      const country_code = item && item.country_code
      if (phone_code) {
        options.push({
          label: name,
          value: JSON.stringify({
            id: id,
            name: name,
            icon: icon[`cif${country_code}`],
            phone_code: phone_code,
          })
        })
      }
    })
    options = [
      ...options,
    ]
  }
  return options
};

export const singleTemplateMessageOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      const languange = item && item.language
      options.push({
        label: name,
        value: id,
        languange: languange
      })
    })
    options = [
      ...options,
    ]
  }
  return options
}

export const singleContactOptionSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const waId = item && item.wa_id
      const name = item && item.profile_name
      options.push({
        label: `${name} (${waId})`,
        value: waId,
      })
    })
    options = [
      ...options,
    ]
  }
  return options
}